export const CHANNEL_RECONCILE_STALE_MS = 30_000
export const CHANNEL_RECONCILE_RETRY_MS = 10_000

export function shouldReconcileOnSubscribe({
    now = Date.now(),
    dataUpdatedAt = 0,
    lastAttemptAt = 0,
    staleMs = CHANNEL_RECONCILE_STALE_MS,
    retryMs = CHANNEL_RECONCILE_RETRY_MS,
    hasCacheEntry = true,
    isLocalOnly = false,
}: {
    now?: number
    dataUpdatedAt?: number
    lastAttemptAt?: number
    staleMs?: number
    retryMs?: number
    hasCacheEntry?: boolean
    isLocalOnly?: boolean
}) {
    if (isLocalOnly) return false
    if (lastAttemptAt && now - lastAttemptAt < retryMs) return false
    if (!hasCacheEntry) return true
    if (!dataUpdatedAt) return true
    return now - dataUpdatedAt >= staleMs
}
